module.exports = __webpack_public_path__ + "static/media/Bayan_logo1.849bf51f.png";